import React, { FC } from 'react'
import { useFormContext } from 'react-hook-form'

import { ProjectCreateHelper } from 'modules/ProjectCreate/components'
import { helperInfo } from 'modules/ProjectEdit/constants'
import FieldInformation from './FieldInformation'

import { IProjectForm } from '../../types'
import { ProjectInformationProps } from './ProjectInformation.props'
import { ConditionRender } from 'components'

const ProjectInformation: FC<ProjectInformationProps> = ({
  teamTitle = 'Local Team Information',
  infoTitle = 'Local Project Information',
  wellTitle,
  wellText,
  dimensions = 'default'
}) => {
  const { control } = useFormContext<IProjectForm>()

  return (
    <>
      <FieldInformation
        dimensions={dimensions}
        title={teamTitle}
        name="teamInfo"
        control={control}
        content={<FieldInformation title={infoTitle} name="info" control={control} size="full" />}
      >
        <ProjectCreateHelper dark>
          <>
            <ConditionRender condition={!!wellTitle} component={<h4>{wellTitle}</h4>} />
            <p>{wellText || helperInfo.customizeProject}</p>
          </>
        </ProjectCreateHelper>
      </FieldInformation>
    </>
  )
}

export default ProjectInformation
